import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { BProps, IIctRisk } from 'store/ducks/Reportings/types';
import { columnsRiskSource } from 'constants/reportColumns';

const RolesAndResponsibilities: React.FC<BProps> = ({ entityName }) => {
  const { is_displayed, date } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<IIctRisk[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    if (!entityName) return;

    const entityIds = entityName.split(',').map((id) => id.trim());

    try {
      const fetchedData = await reportingOp.getICTRiskSource(
        entityIds[0],
        date,
      );

      if (fetchedData && fetchedData.ict_risks) {
        const allEntities = Object.values(fetchedData.ict_risks).flat();
        const formattedData: IIctRisk[] = allEntities.map((dataItem: any) => ({
          entity_name: dataItem.entity_name,
          entity_end_date: dataItem.entity_end_date,
          entity_id: dataItem.entity_id,
          entity_reporting_date: dataItem.entity_reporting_date,
          entity_start_date: dataItem.entity_start_date,
          ict_risk_active: dataItem.ict_risk_active,
          ict_risk_description: dataItem.ict_risk_description || '',
          ict_risk_end_date: dataItem.ict_risk_end_date || '',
          ict_risk_id: dataItem.ict_risk_id || 0,
          ict_risk_name: dataItem.ict_risk_name || '',
          ict_risk_start_date: dataItem.ict_risk_start_date || '',
          ict_system_description: dataItem.ict_system_description || '',
          ict_system_end_date: dataItem.ict_system_end_date || '',
          ict_system_id: dataItem.ict_system_id || 0,
          ict_system_name: dataItem.ict_system_name || '',
          ict_system_start_date: dataItem.ict_system_start_date || '',
          risk_exposure_description: dataItem.risk_exposure_description || '',
          risk_exposure_id: dataItem.risk_exposure_id || 0,
          risk_exposure_name: dataItem.risk_exposure_name || '',
          risk_level_description: dataItem.risk_level_description || '',
          risk_level_id: dataItem.risk_level_id || 0,
          risk_level_name: dataItem.risk_level_name || '',
          risk_source: dataItem.risk_source || [],
        }));

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching ict risk source:', error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [is_displayed, entityName]);

  return (
    <Table<IIctRisk>
      columns={columnsRiskSource}
      dataSource={data.map((item, idx) => ({ ...item, key: idx }))}
      scroll={{ x: 1000, y: 430 }}
    />
  );
};

export default RolesAndResponsibilities;
